import { Injectable } from '@angular/core';

@Injectable()
export class ProgressConfig {
  color = 'primary';
  thickness = 1;
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/@pages/components/progress/progress.config.ts